import { useState, useEffect, useRef } from "react";
import Radio from "backbone.radio";
import { captureBreadcrumb } from "extensions/sentry";
import { MarionetteToReact } from "extensions/MarionetteToReact";
import { ThemeProvider } from "styled-components";

import { ensureErrorCallback, ErrorView } from "common/components/error";
import { NavigatorOnline } from "common/components/navigatorOnline";
import { AppLayout } from "common/layouts/appLayout";
import { theme } from "common/themes/styled";

import { MerchantRouter } from "./router";

export function MerchantApp() {
    const [error, setError] = useState(null);
    const [setupCompleted, setSetupCompleted] = useState(false);
    const mnLayout = useRef();
    // Attaches useful events/requests to Backbone which are used throughout the app.
    const mnController = useRef();

    useEffect(() => {
        const setup = async() => {
            try {
                Radio.channel("app").reply("error:show", setError);

                Radio.channel("app").reply("get:layout", () => {
                    if (error) {
                        return null;
                    }
                    
                    return mnLayout.current.marionetteView;
                });
                
                const { PazienController } = await import("common/controllers/pazienController");
                mnController.current = new PazienController();

                setSetupCompleted(true);
            } catch (error_) {
                captureBreadcrumb({
                    message: "Caught error at app's componentDidMount",
                    data: {
                        error: error_
                    }
                });
                
                if (error_.name === "ChunkLoadError") {
                    ensureErrorCallback(error_, () => setError(error_));
                } else {
                    setError(error_);
                }
            }
        };

        setup();
        return () => Radio.channel("app").off().stopReplying();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (error) {
        return <ThemeProvider theme={theme}><ErrorView error={error} inline={false} /></ThemeProvider>;
    }

    return (
        <ThemeProvider theme={theme}>
            <MarionetteToReact className="marionette-app-wrapper" ref={mnLayout} View={AppLayout}/>
            {setupCompleted && <MerchantRouter />}
            <NavigatorOnline/>
        </ThemeProvider>
    );
}
